import { NgModule } from "@angular/core";
import { AuthImagePipe } from "./authImage.pipe";


@NgModule({
    imports:[],
    declarations:[AuthImagePipe],
    exports:[AuthImagePipe]
})
export class AuthImage{}